<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="8" nzXl="10">
        <h1 class="page-title">Status
            <span nz-icon nzType="reload" nzTheme="outline" class="reloadDateIcon notPrintable cursor"
                (click)="loadStatusData()" nz-tooltip nzTooltipTitle="Reload Data"
                nzTooltipPlacement="bottomLeft"></span>
        </h1>
        <button nz-button nzType="primary" class="right_margin new-btn ml-1" (click)="expandAll()"
            *ngIf="lst_Status.length"> <span nz-icon [nzType]=" isExpandAll ? 'right-circle' : 'down-circle'"
                nzTheme="outline"></span> {{isExpandAll ? 'Expand' : 'Collapse'}} All</button>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="14" class="btnsearch">
        <div class="header-right-box change_ship_date">
            <a nz-button nzSize="large" nzType="link" [disabled]="setOfCheckedIdAccountData.size == 0"
                class="notPrintable" (click)="showChangeShipDate()">Change Ship Date and BL Status</a>
            <nz-select [(ngModel)]="currentStatus" class="mr-1" style="width: 48%;" [disabled]="isStatusLoaded"
                (ngModelChange)="checkStatusToGetRecords()">
                <nz-option [nzValue]="1" nzLabel="All"></nz-option>
                <nz-option [nzValue]="2" nzLabel="Incompleted"></nz-option>

            </nz-select>
            <div class="date-filter-div">
                <input type="text" class="form-control date-picker input mr-1" [readonly]="true" ngxDaterangepickerMd
                    [(ngModel)]="selected" (ngModelChange)="onDateChange($event)" placeholder="Filter By Date"
                    [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [opens]="'left'"
                    [showClearButton]="true">
                <!-- <span class="clear-icon pointer" nz-icon nzType="close-circle" nzTheme="outline"
                    (click)="clearDateFiler($event)"></span> -->
                <!-- <nz-range-picker [(ngModel)]="filterDate" [nzInputReadOnly]="true" [nzFormat]="'MM/dd/yyyy'"
                (ngModelChange)="onDateChange($event)" class="mr-1"></nz-range-picker> -->
            </div>
            <input type="text" class="right_margin search-input" nz-input
                placeholder="Search here by type at least 3 character ..." [(ngModel)]="searchText"
                (keyup)="onSearch($event)" />
            <i nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                nzTooltipTitle="You need to wait for 3 seconds after search apply" class="notPrintable"></i>
        </div>
    </div>
</div>

<div class="table-height" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header statusTable" #sortTable [nzData]="lst_Status" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Status.length > 0 || isStatusLoaded}">
        <thead>
            <tr class="tableheader">
                <!-- <th nzWidth="60px"></th> -->
                <th class="th-checkbox-width" nzWidth="45px" [(nzChecked)]="checkedAccountData"
                    [nzIndeterminate]="indeterminateAccountData" (nzCheckedChange)="onAllCheckedAccountData($event)">
                </th>

                <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('invoice')">QB
                    Invoice#
                </th>
                <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('name')">QB Customer
                    Name
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('poNumber')">PO Number
                </th>
                <th nzWidth="130px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbshipdate')">QB
                    Ship Date
                </th>
                <th nzWidth="153px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbpaymentstatus')">
                    QB Pmt Status</th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbblstatus')">QB BL
                    Status</th>
                <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbshipvia')">QB Ship
                    Via
                </th>
                <th nzWidth="180px" [nzAlign]="'left'">QB Delivery Phone</th>
                <th nzWidth="80px" [nzAlign]="'center'">Called</th>
                <th nzWidth="150px" [nzAlign]="'left'">QB Tracking</th>
                <th nzWidth="120px" [nzAlign]="'center'" [nzSortFn]="true" (nzSortOrderChange)="sort('ship')">Ship</th>
                <th nzWidth="120px" [nzAlign]="'right'">    </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let data of lst_Status;let i = index;let even=even;">
                <tr [ngClass]="{'expanded'  : data.expand, 'is-even-row' : even}" class="pointer"
                    (click)="onExpandChange(i,!data.expand,data,data.id)">
                    <td [nzChecked]="setOfCheckedIdAccountData.has(data.id)"
                        (nzCheckedChange)="onItemCheckedAccountData(data.id, $event)">
                    <td [nzAlign]="'center'" [(nzExpand)]="data.expand"
                        (nzExpandChange)="onExpandChange(i,!data.expand,data,data.id)" [nzAlign]="'left'">
                        <span><a [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+data.transactionID"
                                target="_blank">{{ data.invoiceNo }} </a> </span>
                    </td>

                    <!--nzEllipsis nz-tooltip
                    [nzTooltipTitle]="(data.customerName?.toString().length > 20) ? data.customerName : ''"-->
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.customerName">{{
                        data.customerName }}</td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.poNumber?.length > 10 ? data.poNumber : ''" nzTooltipPlacement="bottomLeft" >
                        <a [ngClass]="!data.poNumber ? 'c-n-allow' : ''"
                        (click)="!data.poNumberDeepLink ? $event.preventDefault() : null"
                        [href]="data.poNumberDeepLink" target="_blank">{{data.poNumber ? data.poNumber : '-'}}</a></td>
                    <td [nzAlign]="'left'"> {{(data.qB_ShipDate.toString().slice(0,-1) | date : 'MM/dd/yyyy') ==
                        '01/01/0001'? '-'
                        : (data.qB_ShipDate.toString().slice(0,-1) | date : 'MM/dd/yyyy' )}}</td>
                    <td [nzAlign]="'left'"><span class="status-text"
                            [ngClass]="{'paid' : data.qB_PaymentStatus == 'Paid' , 'unpaid' : data.qB_PaymentStatus == 'UnPaid', 'partial-paid' : data.qB_PaymentStatus == 'PartiallyPaid'}">{{
                            data.qB_PaymentStatus }}</span> </td>
                    <!--nzEllipsis nz-tooltip
                    [nzTooltipTitle]="(data.qB_BL_Status?.toString().length > 15) ? data.qB_BL_Status : ''"-->
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.qB_BL_Status ? (data.qB_BL_Status | uppercase) : '-'">{{
                        data.qB_BL_Status ? (data.qB_BL_Status | uppercase) : '-' }}
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.qB_ShipVia?.length > 5 ? (data.qB_ShipVia) : ''">{{
                        data.qB_ShipVia ? (data.qB_ShipVia) : '-' }}
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.qB_DeliveryPh ? data.qB_DeliveryPh : '-'">{{ data.qB_DeliveryPh ?
                        data.qB_DeliveryPh : '-' }}
                    </td>
                    <td [nzAlign]="'center'">
                        <div class="check-box ml-0">
                            <label nz-checkbox [(ngModel)]="data.isCalled"
                                (ngModelChange)="changeCalledStatus(data)"></label>
                        </div>
                    </td>
                    <td [nzAlign]="'left'">{{ data.qB_TrackingNo ? data.qB_TrackingNo : '-' }}</td>
                    <td [nzAlign]="'center'">
                        <span class="assignmentFont" nz-typography nzType="danger" *ngIf="!data.isAssignmentValid"><a
                                (click)="showAssignmentEdit(data,data.stocks)" class="assignlink">Invalid Assignment</a>
                        </span>
                        <a nz-button nzType="default" class="shipButton"
                            *ngIf="(data.qB_BL_Status.toLowerCase().includes('std')) && data.isAssignmentValid"
                            target="_blank"
                            [href]="'https://badeloft.starship.online/Sources?SourceID=501&CompanyName=Badeloft%20USA&DocumentKeys='+data.invoiceNo+'&DocumentType=Invoices&ShipmentID=0&UrlActionEnum=CreateShipment&UrlAction=CreateShipment&IsOccupySeatAction=True&IsRateOnly=False'">Ship</a>
                        <a (click)="$event.stopPropagation()" nz-button nzType="default" class="shipButton"
                            *ngIf="(data.qB_BL_Status.toLowerCase().includes('shipped') || data.qB_BL_Status.toLowerCase().includes('picked')) && data.isAssignmentValid"
                            nz-popconfirm nzPopconfirmTitle="Are you sure the order is Shipped?" nzCancelText="No"
                            nzOkText="Yes" (nzOnConfirm)="handleOkRoute(data)"
                            (nzOnCancel)="hideCompletionPopConfirm(data.id)"
                            [nzPopconfirmVisible]="popConfirmVisible && currentCheckBoxId == data.id">Complete</a>
                    </td>
                    <td [nzAlign]="'right'" class="d-flex align-items-center">
                        <!-- <a *ngIf="data.qB_BL_Status.toLowerCase().includes('shipped') || data.qB_BL_Status.toLowerCase().includes('picked')" class="pr-1" nz-popconfirm
                            nzPopconfirmTitle="Are you sure the order is Shipped?" nzCancelText="No" nzOkText="Yes"
                            (nzOnConfirm)="confirmShippingCompletion(data.id)" (nzOnCancel)="hideCompletionPopConfirm(data.id)"
                            [nzPopconfirmVisible]="popConfirmVisible && currentCheckBoxId == data.id">
                            <label nz-checkbox 
                                [ngModel]="setOfCheckedId.has(data.id)"
                                (ngModelChange)="toggleShippingPopConfirm($event,data.id)" class="vm">
                            </label>
                        </a> -->
                        <img [src]="data.isSDAttachment ? '../assets/images/greenDot.png' : '../assets/images/redDot.png'"
                            width="10" height="10" class="mr-1 vm">
                        <span class="mr-1" nz-icon [nzType]="'sync'" nzTheme="outline" (click)="resyncInvoice(data); $event.stopPropagation()" [nzSpin]="data.isResyncing"></span>
                        <span class="mr-1" nz-icon nzType="cloud-sync" nzTheme="outline" nz-tooltip
                            [nzTooltipTitle]="data.qB_TrackingNo ? 'Sync from AfterShip' : 'No tracking number'"
                            [ngClass]="{'disable-icon' : !data.qB_TrackingNo}"
                            (click)="$event.stopPropagation(); showAfterShipSync(data)"></span>
                        <a class="mr-1" (click)="$event.stopPropagation();showHistoryModal(data)" nz-tooltip
                            nzTooltipTitle="View Audit Log(s)"><img src="../assets/images/Audit-Icon.png"> </a>
                    </td>
                </tr>
                <tr [nzExpand]="data.expand">
                    <nz-table class="child-table mt-1" nzTableLayout="fixed" #basicTable [nzData]="data.stocks"
                        [nzShowPagination]="false" [nzScroll]="{ y: 'calc(100vh - 30em)' }" [nzPageSize]="10"
                        [nzTotal]="data.stocks?.length" [nzFrontPagination]="false"
                        [ngClass]="{'table-loading' :lst_Status.length > 0 ||  isStatusLoaded, 'child-table' : !isStatusLoaded}">
                        <thead>
                            <tr>
                                <th nzWidth="50px" [nzAlign]="'center'">#</th>
                                <th nzWidth="15%" [nzAlign]="'left'">Stock Name</th>
                                <th nzWidth="15%" [nzAlign]="'left'" [nzSortFn]="true"
                                    (nzSortOrderChange)="sortPart(!isAscPart,data.stocks)">Part Number</th>
                                <th nzWidth="15%" [nzAlign]="'left'">ETA Date</th>
                                <th nzWidth="15%" [nzAlign]="'left'">Stock Location</th>
                                <th nzWidth="150px" [nzAlign]="'left'">PO Number</th>
                                <th nzWidth="150px" [nzAlign]="'left'">Notes</th>
                                <th nzWidth="100px" [nzAlign]="'right'">Action</th>
                            </tr>
                        </thead>
        <tbody *ngIf="!isStatusLoaded">
            <ng-container>
                <tr *ngFor="let p of basicTable.data;let pi = index;" [ngClass]="{'is-even-row' : even}">
                    <td [nzAlign]="'center'"></td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="p.stockName">{{p.stockName }}</td>
                    <td [nzAlign]="'left'">
                        {{ p.partNumber }} ({{p.assignedQuantity}})
                    </td>
                    <td [nzAlign]="'left'">{{ p.etaDate | date : 'MM/dd/yyyy' }}</td>

                    <td [nzAlign]="'left'">
                        {{ p.stockStatus == 1 ? 'In Production' : (p.stockStatus ==
                        3 ? 'In Warehouse' : 'On Water' )}}</td>
                    <td [nzAlign]="'left'" [nzEllipsis] nz-tooltip
                        [nzTooltipTitle]="data.poNumber ? data.poNumber : '-'"><a [ngClass]="!data.poNumber ? 'c-n-allow' : ''"
                        (click)="!data.poNumberDeepLink ? $event.preventDefault() : null"
                        [href]="data.poNumberDeepLink" target="_blank">{{ data.poNumber ? data.poNumber : '-' }}</a>
                    </td>
                    <td [nzAlign]="'left'" [nzEllipsis] nz-tooltip [nzTooltipTitle]="data.note ? data.note : '-'">{{
                        data.note ? data.note : '-' }}</td>
                    <td [nzAlign]="'right'">
                        <a [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}" nz-popconfirm
                            nzPopconfirmTitle="Are you sure want to remove stock?"
                            (nzOnConfirm)="removePartNumber(p,data,i,pi)" [nzIcon]="iconTpl"
                            [nzPopconfirmTrigger]=" (data.qB_BL_Status | lowercase) == 'shipped' ? null : 'click'"><img
                                [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}"
                                class="mr-1 close-icon" src="./assets/images/Close.svg"></a>
                        <ng-template #iconTpl>
                            <i nz-icon nzType="question-circle-o" style="color: red;"></i>
                        </ng-template>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <tbody *ngIf="isStatusLoaded">
            <tr *ngFor="let i of [].constructor(7)">
                <ng-container *ngFor="let i of [].constructor(8)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </nz-table>
    </tr>
    </ng-container>
    </tbody>
    <ng-container *ngIf="isStatusLoaded">
        <tbody>
            <tr *ngFor="let i of [].constructor(100)">
                <ng-container *ngFor="let i of [].constructor(13)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
    </nz-table>
</div>
<app-audit-history *ngIf="isAuditVisible" [entityType]="entityType" [entityDetails]="entityDetails"
    (hideModal)="hideAuditModal($event)"></app-audit-history>
<app-aftership-sync *ngIf="afterShipOrder" [order]="afterShipOrder"
    (hideModal)="hideAfterShipSync($event)"></app-aftership-sync>

<!-- Change Ship date and BL_status  -->
<nz-modal nzCentered class="custom-modal" [nzMaskClosable]="false" [(nzVisible)]="isShowChangeShipDate"
    [nzTitle]="'Change Ship Date And BL Status' " [nzWidth]="800" nzOkText="Save" nzCancelText="Cancel"
    (nzOnCancel)="handleCancel()" (nzOnOk)="changeShipDate()">
    <ng-container *nzModalContent>
        <div class="modal-height">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Ship date is required"
                            class="input-field input-box required-input-icon">
                            <nz-form-label nzRequired nzFor="date" class="modal-label"> Ship Date
                            </nz-form-label>
                            <br>
                            <nz-date-picker [(ngModel)]="shipDate" nzPlaceHolder="Select Ship Date"
                                [nzAllowClear]="false" [nzInputReadOnly]="true" [nzFormat]="'MM/dd/yyyy'">
                            </nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div class="gutter-row" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                    <nz-form-item>
                        <nz-form-control class="input-field input-box required-input-icon">
                            <nz-form-label nzFor="Name" class="modal-label">QB BL Status</nz-form-label>
                            <input nz-input [(ngModel)]="bl_Status" id="Name" class="input"
                                placeholder="Enter QB BL Status" autocomplete="off" maxlength="30" />
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </div>
    </ng-container>
</nz-modal>

<app-add-update-assignment *ngIf="isAssignmentVisible" [editAssignmentDetail]="editAssignmentDetail"
    (hideModal)="hideModal($event)">
</app-add-update-assignment>

<!--modal to select protect route-->
<!-- <nz-modal [nzMaskClosable]="false" [(nzVisible)]="isVisibleRouteModal" nzTitle="Route Protection" nzCentered
    (nzOnCancel)="handleCancelRoute()" [nzFooter]="footerTpl">
    <ng-container *nzModalContent>
        <label nz-checkbox [(ngModel)]="isRouteEnabled">Add Route Protection</label>
    </ng-container>
    <ng-template #footerTpl>
        <button nz-button (click)="handleCancelRoute()">Cancel</button>
        <button nz-button (click)="handleOkRoute()">Save</button>
    </ng-template>
</nz-modal> -->